module.exports = __webpack_public_path__ + "img/illustration_mobile_es.9b78fc5a.png";